<template>
    <div class="hero">
        <div class="container">


            <div class="hero-texting">
                <h1>Busca tu sala mas próxima</h1>
                <p>reserva y disfruta de tus reuniones</p>
            </div>

            <div class="main-search-wrapper">
                <div class="inner animated">

                    <div class="col-xs-12 col-sm-12 form-lg">
                        <div class="typeahead-container form-group form-icon-right">
                            <label class="destination-search-3">¿Dónde quieres hacer la reunión?</label>
                            <div class="typeahead-field">
                                <gmap-autocomplete
                                        id="searchTextField"
                                        class="form-control"
                                        :placeholder="city"
                                        :types=types
                                        :selectFirstOnEnter=true
                                        @place_changed="setCity"
                                        :componentRestrictions="restrictions"/>
                            </div>
                            <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="row">
                            <div class="col-sm-6 col-sm-offset-6 col-md-6 col-md-offset-6 text-center">
                                <button class="btn btn-block btn-lg btn-icon">Buscar <span class="icon">
                                    <font-awesome-icon icon="search"/>
                                </span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        name: 'searcher',
        data: function () {
            return {
                results: '',
                city: 'Introduce la población',
                restrictions: {country: 'es'},
                types: ["(cities)"]
            }
        },
        methods: {
            setCity(description) {
                let cname = description.name.split(",");
                this.city = cname[0];
                this.$router.push('/catalogue/' + this.city);
            },
            getLocation() {
                this.$getLocation({
                    enableHighAccuracy: true,
                    timeout: Infinity,
                    maximumAge: 0
                }).then(coordinates => {
                    this.getCity(coordinates.lat, coordinates.lng);
                });
            },
            async getCity(lat, lng) {
                let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng + "&sensor=true&key=AIzaSyA2Tgqo5TnQXFB5C_SXx54Okvcqd3WdH8Q";
                const productresult = await axios.get(url);
                this.results = Object.freeze(productresult);
                this.city = this.results.data.results[4].formatted_address;
            }

        },
        created() {
            this.getLocation();
        }
    }
</script>
<style scoped>
    .btn-icon {
        background: #8ac6c4 !important;
    }

    .btn-icon:hover {
        color: #FFF !important;
    }
</style>